import { UserBalance } from "../../models/models";

export function getEmptyUser(): UserBalance
{
		return {
			type: 'USER',
			status: 'ACTIVE',
			code: '',
			creation_store_id: 1,
			workshift_id: null,
			birthday: null,
			credit_limit: 0,
			role_id: null,
			credit_days: 0,
			created_by_user_id: null,
			created_by_store_id: null,
			updated_by_user_id: null,
			default_shipping_address_id: null,
			default_billing_address_id: null,
			email: '',
			id: 0,
			image_id: null,
			lat: null,
			lng: null,
			points: 0,
			password: '',
			phone: '',
			platform_client_id: null,
			username: '',
			name: '',
			payment_option: 'STORE',
			payment_address_id: null,
			price_type_id: 0,
			preferred_store_id: null,
			printer_id: null,
			production_area_id: null,
			store_id: null,
			balance: 0,
			agent_name: '',
			installment_expired_qty: 0,
			installment_expired_amount: 0,
			installment_expired_since: new Date(),
			installment_last_payment: new Date(),
			orders_expired_amount: 0,
			last_payment_timestamp: new Date(),
			created: new Date(),
			updated: new Date(),
			job_address: '',
			job_name: '',
			job_phone: ''
		};
}
